import React, { useEffect, useState } from "react";
import "../sections.css";
import { getTarjetasInicio } from "../../../../config/services/strapi/home";
import TextSkeleton from "../../../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../../../components/Skeleton/ImageSkeleton";

export default function NuestroParque() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const tarjetas = await getTarjetasInicio();
        const tarjetaParque = tarjetas.find(
          (t: any) => t.titulo === "NUESTRO PARQUE"
        );
        setData(tarjetaParque);
      } catch (error) {
        console.error("Error cargando Nuestro Parque:", error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  const imageUrl = data?.portada?.url || null;

  return (
    <section className="section nuestro-parque">
      <div className="section-inner">
        <div className="col-text">
          {loading ? (
            <TextSkeleton className="relative z-[99999] pointer-events-none" />
          ) : (
            <h1>
              {data?.Titulo?.split(" ").map((word: string, i: number) => (
                <React.Fragment key={`${word}-${i}`}>
                  {word} {i === 0 && <br />}
                </React.Fragment>
              )) || "NUESTRO PARQUE"}
            </h1>
          )}

          <a
            href="/nuestro-parque"
            className="full-link"
            title={data?.Titulo || "Nuestro Parque"}
          />
        </div>

        <div className="col-media">
          {loading ? (
            <ImageSkeleton className="h-full relative z-[99999] pointer-events-none" />
          ) : (
            <div
              className="media-cover"
              style={{
                backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
              }}
            />
          )}

          <a
            href="/nuestro-parque"
            className="full-link"
            title={data?.Titulo || "Nuestro Parque"}
          />
        </div>
      </div>
    </section>
  );
}